import { render, staticRenderFns } from "./MutationForm.vue?vue&type=template&id=208b2596&scoped=true&"
import script from "./MutationForm.vue?vue&type=script&lang=ts&"
export * from "./MutationForm.vue?vue&type=script&lang=ts&"
import style0 from "./MutationForm.vue?vue&type=style&index=0&id=208b2596&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208b2596",
  null
  
)

export default component.exports